import React from "react";

const DataIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9998 0V16H0.319832C0.00183177 16 -0.0961682 15.791 0.103832 15.535L4.57283 9.787C4.61763 9.72693 4.67475 9.67712 4.74036 9.64092C4.80598 9.60472 4.87857 9.58295 4.95327 9.57708C5.02798 9.57121 5.10308 9.58137 5.17354 9.60688C5.244 9.63239 5.3082 9.67266 5.36183 9.725L6.78083 11.059C6.832 11.111 6.89448 11.1504 6.9634 11.1742C7.03232 11.198 7.10582 11.2055 7.17814 11.1963C7.25046 11.187 7.31966 11.1611 7.38032 11.1206C7.44098 11.0801 7.49147 11.0262 7.52783 10.963L10.5748 6.223C10.6109 6.16015 10.6611 6.10659 10.7215 6.06656C10.7819 6.02653 10.8509 6.00114 10.9228 5.9924C10.9947 5.98366 11.0677 5.99182 11.1359 6.01623C11.2042 6.04064 11.2658 6.08062 11.3158 6.133L13.4868 8.229C13.7188 8.454 14.0458 8.409 14.2108 8.129L19.3438 0.344C19.5098 0.0620001 19.7498 0 19.9998 0Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default DataIcon;
